import { RARITIES } from '~/data/gacha'
import type { Rarity } from '~/data/gacha'
import type { DaycareQueueEntry } from '~/utils/daycare'

const KEY_PREFIX = 'pokegrind-dc-reserve-v1-'
const VALID_RARITY = new Set<Rarity>(RARITIES)

function keyForUser(userId: number) {
  return `${KEY_PREFIX}${userId}`
}

/** Sauvegarde locale de secours : évite perte de file si sauvegarde serveur différée (throttle) ou format legacy. */
export function persistDaycareReserveQueueBackup(userId: number | undefined, queue: DaycareQueueEntry[]) {
  if (userId == null || userId <= 0) return
  try {
    localStorage.setItem(keyForUser(userId), JSON.stringify(queue))
  } catch {
    /* ignore */
  }
}

const LAST_USER_KEY = 'pokegrind-last-user-id'

/** Persiste la file d’attente sans dépendre de useAuthStore (évite import circulaire). */
export function persistDaycareReserveQueueBackupForCurrentUser(queue: DaycareQueueEntry[]) {
  try {
    const s = typeof localStorage !== 'undefined' ? localStorage.getItem(LAST_USER_KEY) : null
    const id = parseInt(s ?? '', 10)
    if (Number.isFinite(id) && id > 0) persistDaycareReserveQueueBackup(id, queue)
  } catch {
    /* ignore */
  }
}

export function setLastUserIdForLocalBackup(userId: number | undefined) {
  if (userId == null || userId <= 0) return
  try {
    localStorage.setItem(LAST_USER_KEY, String(userId))
  } catch {
    /* ignore */
  }
}

export function clearDaycareReserveQueueBackup(userId: number | undefined) {
  if (userId == null || userId <= 0) return
  try {
    localStorage.removeItem(keyForUser(userId))
  } catch {
    /* ignore */
  }
}

export function clearDaycareReserveQueueBackupForCurrentUser() {
  try {
    const s = typeof localStorage !== 'undefined' ? localStorage.getItem(LAST_USER_KEY) : null
    const id = parseInt(s ?? '', 10)
    if (Number.isFinite(id) && id > 0) clearDaycareReserveQueueBackup(id)
  } catch {
    /* ignore */
  }
}

export function loadDaycareReserveQueueBackup(userId: number): DaycareQueueEntry[] | null {
  if (userId <= 0) return null
  try {
    const raw = localStorage.getItem(keyForUser(userId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return null
    const out: DaycareQueueEntry[] = []
    for (const item of parsed) {
      if (!item || typeof item !== 'object') continue
      const o = item as Record<string, unknown>
      const slug = typeof o.slug === 'string' ? o.slug : ''
      if (!slug) continue
      const r = String(o.rarity ?? 'common')
      const rarity = VALID_RARITY.has(r as Rarity) ? (r as Rarity) : 'common'
      out.push({
        slug,
        nameFr: typeof o.nameFr === 'string' ? o.nameFr : slug,
        nameEn: typeof o.nameEn === 'string' ? o.nameEn : slug,
        rarity,
        isShiny: Boolean(o.isShiny),
        stars: Math.max(1, Math.min(5, Math.floor(Number(o.stars) || 1))),
      })
    }
    return out.length > 0 ? out : null
  } catch {
    return null
  }
}
